var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChinaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1451_85989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.1L4.9 9.4L7 4L8.8 9.4L4 6.1H10Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2413 3.2908L13.0585 4.18084L11.1563 4.50767L12.3894 3.06727L12.2706 5.00397L11.2413 3.2908Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5575 5.05511L14.886 6.58316L13.0053 6.14377L14.7028 5.29613L13.8393 7.03516L13.5575 5.05511Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9755 7.95797L14.5647 9.89636L13.0265 8.7267L14.9232 8.64605L13.424 9.88153L13.9755 7.95797Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.391 10.0328L12.1865 12.0463L11.22 10.3753L12.999 11.0323L11.141 11.5928L12.391 10.0328Z",
    fill: "#FFDE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1451_85989"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinaFlag);
export default __webpack_public_path__ + "static/media/china_flag.0450ee886e1f0d456ec036c134934032.svg";
export { ForwardRef as ReactComponent };